import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';


const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <img 
          src="/images/hero-Bg.svg" 
          alt="Conference Background" 
          className="hero-background"
        />
        <div className="hero-overlay first-section fade-in-up">
          <div className="hero-logo-container">
            <img 
              src="/images/logo.png" 
              alt="Conference Logo" 
              className="hero-logo"
            />
          </div>
          <h1 className="hero-title">2nd International Conference on Engineering Structures</h1>
          <h2 className="hero-subtitle">ICES2026: BRISBANE</h2>
          <p className="hero-date">1-4 December 2026, Brisbane Convention & Exhibition Centre</p>
          <div className="button-container">
            <Link to="/registration" id="register-button">Register / Buy Ticket</Link>
            <a href="https://ices2026-portal.com" target="_blank" rel="noreferrer" id="system-button">Submission Portal</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
